function switchColors() {
  const newCarColors = document.querySelectorAll('.new-car-colors');
  let injectStyle = document.createElement("style");
  let baseColors = '';
  let carsInternalColors = '';

  newCarColors.forEach((car) => {
    let carId = car.getAttribute("data-car-id");
    let color = car.getAttribute("data-color");

    if (color) {
      baseColors = `
        .car-${carId}::before {
          background-color: ${color};
        }

        .car-${carId} .btn-color {
          background-color: ${color};
          border: 1px solid ${color};
          color: #FFFFFF;
        }

        .car-${carId} .btn-color:hover,
        .car-${carId} .btn-color:focus {
          background-color: #FFFFFF;
          color: ${color};
        }
      `;

      carsInternalColors = `
        .new-car-section.car-${carId} .swiper-button-next,
        .new-car-section.car-${carId} .swiper-button-prev {
          background-color: ${color};
        }

        .new-car-section.car-${carId} .new-car-highlights-container {
          background-color: ${color};
        }

        .new-car-section.car-${carId} .new-car-highlights-container
          .tabs-style.active {
          color: ${color};
        }

        .new-car-section.car-${carId} .new-car-gallery-container
          .tabs-style.active {
          background-color: ${color};
        }

        .new-car-section.car-${carId} .new-car-gallery-container
          .gallery-content {
          background-color: ${color};
        }

        .new-car-section.car-${carId} .new-car-datasheet-swiper
          .tabs-style.active .new-car-datasheet-name {
          color: ${color};
        }

        .new-car-section.car-${carId} .new-car-datasheet-content
          li::marker {
          color: ${color};
        }
      `
    }

    injectStyle.innerHTML += carsInternalColors;
    injectStyle.innerHTML += baseColors;
    document.head.appendChild(injectStyle);
  });
}

module.exports = {
  switchColors
}
